module.exports = __webpack_public_path__ + "img/image1 copy.c7ac9cfb.jpg";